import React from 'react';
import PropTypes from 'prop-types';

import { ArrowRight } from '@components/icons/arrow/arrow';
import Link from 'next/link';

import Headline from '@components/atoms/headline/headline';
import StyledEducationArrowLink from './educationArrowLink.style';

const EducationArrowLink = ({ href, children = <span>Zur Bibliothek</span> }) => {
  return (
    <StyledEducationArrowLink>
      <Link href={href || '/de/bildung/bibliothek'} className="arrow-link">
        <Headline tag="span" className="arrow-link__title">
          {children}
        </Headline>
        <span className="arrow-link__icon">
          <ArrowRight />
        </span>
      </Link>
    </StyledEducationArrowLink>
  );
};

EducationArrowLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node
};

export default EducationArrowLink;
